import 'twin.macro'

import FFLogo from 'assets/icons/ff-logo.svg?component'
import BodyText from 'components/UI/Landing/body-text'
import Container from 'components/UI/Landing/container'
import { useMemo } from 'react'
import { useTranslation } from 'react-i18next'

import SuperappBanner from './superapp-banner'

export default function FooterDesktop() {
  const { t } = useTranslation('footer')

  const footerLinks = useMemo(
    (): { group: string; links: { title: string; link: string }[] }[] => [
      {
        group: t('footer.for-customer'),
        links: [
          { title: t('footer.customer-link-1'), link: 'https://bankffin.kz/ipoteka/' },
          { title: t('footer.customer-link-2'), link: 'https://auto.bankffin.kz' },
          { title: t('footer.customer-link-3'), link: 'https://bankffin.kz/ru/cards' },
          {
            title: t('footer.customer-link-4'),
            link: 'https://bankffin.kz/ru/loan/payment/repayment-loans#/'
          },
          { title: t('footer.customer-link-5'), link: 'https://bankffin.kz/ru/deposits/ph' },
          {
            title: t('footer.customer-link-6'),
            link: 'https://bankffin.kz/ru/transfers'
          },
          {
            title: t('footer.customer-link-7'),
            link: 'https://bankffin.kz/ru/page/35-restrukturizatsiya-zaymov'
          },
          {
            title: t('footer.customer-link-8'),
            link: 'https://bankffin.kz/ru/save-id/send-otp'
          },
          { title: t('footer.customer-link-9'), link: 'https://bankffin.kz/ru/page/safes' },
          { title: t('footer.customer-link-10'), link: 'https://bankffin.kz/ru/page/priority' }
        ]
      },
      {
        group: t('footer.for-business'),
        links: [
          { title: t('footer.business-link-1'), link: 'https://bankffin.kz/ru/guarantees' },
          { title: t('footer.business-link-2'), link: 'https://overdraft.bankffin.kz/' },
          { title: t('footer.business-link-3'), link: 'https://bankffin.kz/ru/deposits/jr' },
          { title: t('footer.business-link-4'), link: 'https://bankffin.kz/ru/e-commerce' },
          { title: t('footer.business-link-5'), link: 'https://bankffin.kz/ru/page/priority' },
          { title: t('footer.business-link-6'), link: 'https://bankffin.kz/ru/page/nova-24' },
          {
            title: t('footer.business-link-7'),
            link: 'https://bankffin.kz/ru/services/account-booking'
          },
          { title: t('footer.business-link-8'), link: 'https://bankffin.kz/ru/unlimited' }
        ]
      },
      {
        group: t('footer.about'),
        links: [
          { title: t('footer.about-link-1'), link: 'https://bankffin.kz/ru/page/about' },
          { title: t('footer.about-link-2'), link: 'https://bankffin.kz/ru/exchange-rates' },
          { title: t('footer.about-link-3'), link: 'https://bankffin.kz/ru/docs' },
          { title: t('footer.about-link-4'), link: 'https://bankffin.kz/ru/page/requisites' },
          { title: t('footer.about-link-5'), link: 'https://support.bankffin.kz/' }
        ]
      }
    ],
    [t]
  )

  return (
    <footer className='py-7 hidden sm:block'>
      <Container>
        <div className='grid grid-cols-3 gap-x-4 gap-y-10 lg:grid-cols-5'>
          {footerLinks.map((group, idx) => (
            <div key={idx} className='flex-1 sm:col-span-1'>
              <h5 className='text-muted uppercase mb-5'>{group.group}</h5>
              {group.links.map((link, idx) => (
                <a key={idx} href={link.link} className='text-main text-sm mb-2 block'>
                  {link.title}
                </a>
              ))}
            </div>
          ))}
          <div className='flex-1 grid grid-cols-5 gap-x-4 gap-y-10 sm:col-span-3 lg:col-span-2 lg:grid-cols-1 lg:gap-x-0'>
            <div className='col-span-2 space-y-5 '>
              <FFLogo tw='w-24 flex-shrink-0' />
              <BodyText text={t('footer.address')} />
            </div>
            <SuperappBanner className='col-span-3' />
          </div>
        </div>
      </Container>
    </footer>
  )
}
